import { ref, createVNode } from 'vue'
const weekDay = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

export default function useAppointSetting() {
  const itemRefs = ref([])
  const submitData = ref([]) // 最后要提交的数据格式
  // 格式化排班信息
  const setTime = ctxTime => {
    const weekOption = []
    weekDay.forEach(() => {
      weekOption.push({
        morning: false,
        evening: false
      })
    })
    if (ctxTime) {
      Object.values(ctxTime).forEach((el, index) => {
        const [mor, eve] = el
        weekOption[index] = {
          ...weekOption[index],
          morning: Boolean(mor),
          evening: Boolean(eve)
        }
      })
    }
    return weekOption
  }
  // 格式化要提交的数据
  const formatData = list => {
    if (list?.length) {
      submitData.value = list.map((item, index) => {
        const {
          consultationTime,
          ucDoctorId,
          registerFlag,
          drOutpatientInfoId,
          hospitalName,
          firstHospitalFlag
        } = item || {}
        const weekOption = setTime(JSON.parse(consultationTime))
        return {
          ucDoctorId,
          registerFlag,
          drOutpatientInfoId,
          weekOption,
          hospitalName,
          firstHospitalFlag
        }
      })
    } else {
      submitData.value = []
    }
  }
  // 处理排班信息,判断是否排班时间冲突
  const canSchedule = (param, curIndex) => {
    const { status, type, itemIndex } = param
    const _submitData = submitData.value
    if (status) {
      const isSchedule = (
        _submitData.map(item => item.weekOption[itemIndex][type]) || []
      ).findIndex(it => it)
      if (isSchedule !== -1) {
        const _week = weekDay[itemIndex]
        const _type = type === 'morning' ? '上午' : '下午'
        const hospitalName = _submitData[isSchedule].hospitalName
        const content = `${_week}${_type}已在${hospitalName}坐诊，是否取消其排班？`
        Modal.confirm({
          title: '提示',
          icon: createVNode(ExclamationCircleOutlined),
          content,
          okText: '确认',
          cancelText: '取消',
          centered: true,
          onOk: () => {
            submitData.value[isSchedule].weekOption[itemIndex][type] = false
            submitData.value[curIndex].weekOption[itemIndex][type] = true
          },
          onCancel: () => {
            //
          }
        })
      } else {
        submitData.value[curIndex].weekOption[itemIndex][type] = true
      }
    } else {
      submitData.value[curIndex].weekOption[itemIndex][type] = status
    }
  }
  // 提交前判断是否设置排班
  const haveSchedule = () => {
    return new Promise(resolve => {
      const emptyList =
        submitData.value.filter(item => {
          // 找出所有预约入口开启但是没有具体排班的医院
          const { weekOption, registerFlag } = item
          return !registerFlag && !weekOption.find(it => it.morning || it.evening)
        }) || []
      if (emptyList.length) {
        // const hospitalName = emptyList.map(it => it.hospitalName).join('、')
        Modal.confirm({
          title: '提示',
          icon: createVNode(ExclamationCircleOutlined),
          content: '医院未设置排班时间，请前往设置。如仍未设置排班，将自动关闭预约入口。',
          okText: '去设置',
          cancelText: '关闭预约',
          centered: true,
          onOk: () => {
            const index = submitData.value.findIndex(
              it => it.drOutpatientInfoId === emptyList[0].drOutpatientInfoId
            )
            const targetElement = itemRefs.value?.[index]
            targetElement?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
            resolve(false)
          },
          onCancel: () => {
            const drOutpatientInfoIdList = emptyList.map(it => it.drOutpatientInfoId)
            submitData.value.forEach(item => {
              const { drOutpatientInfoId } = item
              if (drOutpatientInfoIdList.includes(drOutpatientInfoId)) {
                item.registerFlag = 1
              }
            })
            resolve(true)
          }
        })
      } else {
        resolve(true)
      }
    })
  }
  const addNewHospitalConfig = data => {
    const { registerFlag, ucDoctorId, drOutpatientInfoId, hospitalName, firstHospitalFlag } = data
    submitData.value.push({
      ucDoctorId,
      registerFlag,
      drOutpatientInfoId,
      weekOption: setTime(),
      hospitalName,
      firstHospitalFlag
    })
  }
  return {
    formatData,
    submitData,
    canSchedule,
    haveSchedule,
    itemRefs,
    addNewHospitalConfig
  }
}
